import SpaceVariable from '@/modules/space/models/SpaceVariable'

export type VariableIconState = 'warn' | 'pend' | 'done' | null

function trimToNonEmpty(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim()
  return trimmed || undefined
}

export function getVariableValueFlags(variable: SpaceVariable): {
  hasDefaultValue: boolean
  hasRecipientValue: boolean
  hasRecipient: boolean
  hasDefault: boolean
} {
  const hasDefaultValue = !!trimToNonEmpty(variable.defaultValue)
  const hasRecipientValue = !!trimToNonEmpty(variable.recipientValue)
  const hasRecipient = !!variable.assignedToRecipientId
  const hasDefault = hasRecipient ? hasRecipientValue : hasDefaultValue || hasRecipientValue

  return { hasDefaultValue, hasRecipientValue, hasRecipient, hasDefault }
}

export function getVariableIconState(variable: SpaceVariable): VariableIconState {
  const { hasDefaultValue, hasRecipientValue, hasRecipient } = getVariableValueFlags(variable)

  if (hasRecipientValue) {
    return 'done'
  }
  if (hasRecipient) {
    return 'pend'
  }
  if (hasDefaultValue) {
    return null
  }
  return 'warn'
}

export function getIconStateFromFlags(
  hasDefault: boolean,
  hasRecipient: boolean,
  hasRecipientValue: boolean = false
): VariableIconState {
  if (hasRecipientValue) {
    return 'done'
  }
  if (hasRecipient) {
    return 'pend'
  }
  if (hasDefault) {
    return null
  }
  return 'warn'
}

export function isOrphanFilledVariable(variable: SpaceVariable): boolean {
  return !!trimToNonEmpty(variable.recipientValue) && !variable.assignedToRecipientId
}

export function getEffectiveVariableValue(variable: SpaceVariable): string | null {
  const recipientValue = trimToNonEmpty(variable.recipientValue)
  const defaultValue = trimToNonEmpty(variable.defaultValue)

  if (recipientValue && !variable.assignedToRecipientId) {
    return recipientValue
  }
  return defaultValue ?? recipientValue ?? null
}
